module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/twitter-ed9ff025c51f5fccc43d7728810057cc.png";